<template>
    <transition name="overlay">
        <div v-if="isCreatingChannel" class="overlay" v-shortkey.once="['esc']" @shortkey="close">

            <header class="overlay__header overlay__header--absolute">
                <div class="overlay__container">
                    <span>Create channel</span>
                    <button @click="close" class="icon-button">
                        <icon type="close" color="white" size="18" />
                    </button>
                </div>
            </header>

            <section class="dialog">
                <div class="dialog__body">
                    <form @submit.prevent action="" method="post" class="form form--flex">
                        <div class="form__column w-full mr-0 md:w-2/3 md:mr-12">
                            <div class="form__group" :class="{ 'form__group--error' : form.errors.has('name')}">
                                <label for="name" class="form__label">Name</label>
                                <input v-model="form.name" id="name" name="name" class="lc-name form__input" autofocus autocomplete="off">
                                <p v-if="form.errors.has('name')" class="form__help form__help--error">{{ form.errors.get('name') }}</p>
                            </div>
                        </div>
                        <div class="form__column w-full md:w-1/3">
                            <div class="form__group">
                                <label for="users" class="form__label">Channel members</label>
                                <span class="form__sublabel">Add the people that will participate on this channel</span>
                                <members id="users" v-model="form.users" :users="activeTenantUsers"></members>
                            </div>
                        </div>
                    </form>
                </div>
                <footer class="dialog__footer">
                    <button @click.prevent="createChannel()" type="submit" class="lc-submit button button--primary" :disabled="isBusy">Create channel</button>
                </footer>
            </section>

        </div>
    </transition>
</template>
<script>
/* global EventBus */
import { mapState, mapGetters, mapMutations } from 'vuex'
import Members from './Members'
import Icon from './Icon'
import { CREATE_CHANNEL } from '../../stores/global/actions'
import { CLOSE_CHANNEL_CREATION } from '../../stores/global/mutations'
import Form from '../../helpers/Form'

export default {
    data () {
        return {
            visible: false,
            isBusy: false,
            form: new Form({
                name: '',
                users: []
            })
        }
    },

    created () {
        EventBus.$on('openCreateChannel', this.open)
    },

    methods: {
        ...mapMutations({
            close: CLOSE_CHANNEL_CREATION
        }),

        createChannel () {
            if (this.isBusy) {
                return
            }

            this.isBusy = true

            this.$store.dispatch(CREATE_CHANNEL, this.form).then((response) => {
                window.location.href = response.data.url
            }).catch(() => {
                this.isBusy = false
            })
        },

        clearForm () {
            this.form.name = ''
            this.form.users = []
        }
    },

    computed: {
        ...mapState('users', {
            currentUser: 'current'
        }),

        ...mapState(['isCreatingChannel']),

        ...mapGetters({
            users: 'tenant/sortedUsers'
        }),

        activeTenantUsers () {
            return this.users.filter((user) => user.id !== this.currentUser.id && user.is_active)
        }
    },

    components: {
        Members,
        Icon
    }
}
</script>
